import React from 'react';

import { Box, Card, H3, Separator } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';
import { IraContributionSummaries } from '@betterment/shared-components/src/components/ira-contributions/IraContributionSummaries';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { useActiveIraContributionsByYearQuery } from './hooks';

import urlBuilder from '../../../../Shared/url-builder';
import { ImpersonationLink } from '../../ImpersonationLink';

export const IraContributionOverviewCard: React.FC = () => {
  const householdId = useRequiredParam('householdId');
  const accountId = useRequiredParam('accountId');

  const { isLoading, iraContributions, clientId } = useActiveIraContributionsByYearQuery(householdId, accountId);

  if (isLoading) return <CardLoader />;
  if (!iraContributions?.byYear || !clientId) return null;

  return (
    <Card css={{ padding: 'space.300', display: 'grid', gap: 'space.300', width: '100%' }}>
      <Card.Header>
        <H3 css={{ textStyle: { base: 'title100', md: 'title200' } }}>IRA Contributions</H3>
      </Card.Header>
      <Separator />
      <Card.Content>
        <Box css={{ display: 'grid', gap: 'space.300', marginTop: 'space.25' }}>
          <IraContributionSummaries iraContributions={iraContributions?.byYear || []} />
          <Separator />
          <ImpersonationLink
            showModal={false}
            url={urlBuilder.getImpersonateClientPage.absolute({
              clientId,
              deep_link_path: '/app/ira_details',
            })}
            label="See details"
            variant="textPrimary"
          />
        </Box>
      </Card.Content>
    </Card>
  );
};
